// extracted by mini-css-extract-plugin
module.exports = {"container":"SearchFormSmall_container__2SlRn","wrapper":"SearchFormSmall_wrapper__3sr5a","component":"SearchFormSmall_component__NzWlg","input":"SearchFormSmall_input__17r3O"};